import React, {useState} from "react";
import {useNavigate} from 'react-router-dom';
import {login} from "./apiService";
// import {createHashHistory} from 'history';

const LoginForm = props => {
	const [inputs, setInputs] = useState({});
	// const history = createHashHistory();
	const navigate = useNavigate();

	const handleChange = (event) => {
		const name = event.target.name;
		const value = event.target.value;
		setInputs(values => ({...values, [name]: value}));
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		console.log(inputs);
		login(inputs.username, inputs.password).then(
			data => {
				console.log('data', data);
				if(data.status !== 200) {
					alert(data.message);
					return;
				}
				window.localStorage.setItem('token', data.result.token);
				navigate('/events', {replace: true});
				// history.back();
			},
			error => {
				console.error('error object', error);
			}
		);
	}

	window.localStorage.removeItem('token');
	return (
		<form onSubmit={handleSubmit}>
			<h1>Timesheet Login</h1>
			<table>
			<tbody>
			<tr>
				<td><label htmlFor="username">Name:</label></td>
				<td>
				<input type="text" name="username" id="username"
					value={inputs.username || ""}
					onChange={handleChange} />
				</td>
			</tr>
			<tr>
				<td><label htmlFor="password">Password:</label></td>
				<td>
				<input type="password" name="password" id="password"
					value={inputs.password || ""}
					onChange={handleChange} />
				</td>
			</tr>
			</tbody>
			</table>
			<input type="submit"/>
		</form>
	)
}

export default LoginForm;